module.exports = __webpack_public_path__ + "img/zuanshi1.e7bd6e09.png";